const categories = state => state.categories;
const current = state => state.current;

export {
  categories,
  current,
}